import { IStairConfig, IStepGeometry } from '@stair-craft/common/util';

import { centerToPosition } from '../shared-center-to-position/center-to-position';

export function generateFlight2Steps(
    flight1Count: number,
    turnStepCount: number,
    flight2Count: number,
    riserHeight: number,
    treadDepth: number,
    f2StartZ: number,
    config: IStairConfig,
    startIndex: number
): IStepGeometry[] {
    const steps: IStepGeometry[] = [];
    const sw: number = config.stairWidth;
    const isRight: boolean = config.turnDirection === 'right';
    const baseRiserIndex: number = flight1Count + turnStepCount;

    const f2CenterX: number = isRight ? sw + config.flightGap + sw / 2 : -(config.flightGap + sw / 2);

    for (let j: number = 0; j < flight2Count; j++) {
        const stepY: number = (baseRiserIndex + j + 1) * riserHeight;
        // Riser line j sits j·treadDepth before the turn edge (flight 2 climbs toward −Z); after
        // rotateY(180°) the nose points to +Z and overhangs the step below — the landing for j = 0.
        // The board runs one going behind the riser line plus the nose ahead of it.
        const cz: number = f2StartZ - j * treadDepth - (treadDepth - config.noseLength) / 2;
        const pos: { x: number; z: number } = centerToPosition(f2CenterX, cz, sw, treadDepth, config.noseLength);

        steps.push({
            index: startIndex + j,
            position: { x: pos.x, y: stepY, z: pos.z },
            treadWidth: sw,
            treadThickness: config.treadThickness,
            noseLength: config.noseLength,
            rotation: 180,
            isWinder: false,
            isLanding: false,
            treadDepth,
            riserHeight,
        });
    }

    return steps;
}
